import * as $ from "jquery";

export const PhonePLRule = (() => {
	$.validator.addMethod("phonePL", function (value) {
		let stripped = value.replace(/[ -]/g, "");
		return /^[0-9]{9,}$/.test(stripped);
	}, $.validator.format("Numer telefonu jest niepoprawny"));
})();import * as $ from "jquery";

export const PhonePLRule = (() => {
	$.validator.addMethod("phonePL", function (value) {
		let stripped = value.replace(/[ -]/g, "");
		return /^[0-9]{9,}$/.test(stripped);
	}, $.validator.format("Numer telefonu jest niepoprawny"));
})();